import createTypes from 'redux-create-action-types';

export default createTypes(
  'ADD_ORDER_TO_CART',
  'GET_CART_DETAILS',
  'REMOVE_CART_ITEM',
  'CART_CHECKOUT'
);
